export const KA_TREND_LABELS: {
  key: 'ka1' | 'ka2' | 'ka3' | 'ka4' | 'ka5' | 'ka6' | 'ka7' | 'ka8'
  label: string
}[] = [
  { key: 'ka1', label: '①背景' },
  { key: 'ka2', label: '②期待' },
  { key: 'ka3', label: '③課題' },
  { key: 'ka4', label: '④解決' },
  { key: 'ka5', label: '⑤WOW' },
  { key: 'ka6', label: '⑥料金' },
  { key: 'ka7', label: '⑦必然' },
  { key: 'ka8', label: '⑧信頼' },
]

const CIRCLED_NUMBER_CODE_POINT_BASE = 0x2460 // ①
const CIRCLED_NUMBER_MAX = 20

/** 丸数字（①〜⑳）で表せる整数なら丸数字を、表せない値なら null を返す。 */
export function toCircledNumber(value: number): string | null {
  if (!Number.isInteger(value) || value < 1 || value > CIRCLED_NUMBER_MAX) {
    return null
  }

  return String.fromCodePoint(CIRCLED_NUMBER_CODE_POINT_BASE + value - 1)
}

/**
 * KA ID に対応する丸数字の表示識別子を返す。
 * radarChart の identifier（バックエンドの ①〜⑧）との照合キーを兼ねるため、
 * 表示ラベル文字列には依存させない。
 */
export function getKaIdentifier(kaId: number): string {
  const circled = kaId <= KA_TREND_LABELS.length ? toCircledNumber(kaId) : null
  if (circled == null) {
    return `KA${kaId}`
  }

  return circled
}

/** 因子順位（rank）の表示名を返す。 */
export function getFactorRankLabel(rank: number): string {
  if (rank === 1) {
    return '第一因子'
  }

  if (rank === 2) {
    return '第二因子'
  }

  return `第${rank}因子`
}
